<template>
  <div>

    <breadcrumbs />

    <div class="content-i">
      <div class="content-box">
        <div class="row pt-4">
          <div class="col-sm-12">
            <!--START - User List -->
            <div class="element-wrapper">
              <h6 class="element-header capitalize">

              </h6>
              <div class="element-box-tp">

                  <betMarketLimitations />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import betMarketLimitations from '@/components/user/bets/betMarketLimitations'
    export default {
        name: 'marketLimitations',
        components: {betMarketLimitations},
        data () {
            return {
                t: this.$root.t
            }
        },
        methods () {


        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/configuration/marketLimitations.vue